import React, { useState, useEffect, useRef } from "react";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";
import Button from "../../components/common/Button";
import InputBox from "../../components/common/InputBox";
import Div from "../../components/common/Div";
import { Tex } from "react-tex";
import {
  tenzero,
  tentwentyfive,
  NumberToLetter,
  fixMarginQuestionButtons,
  fixOptions,
} from "../../constants/Constants";
import Image from "../../components/common/Image";
import QuestionText from "../Partials/QuestionText";
import {formatLatexText} from "../../utils/formatLaTex";

export default function Q_Type(props) {
  const [questionRerender, setQuestionRerender] = useState(false);
  const inputRef = useRef(null); // Create a ref for the input field

  const question = props.question;
  const submission = props.submission;
  const questionNumber = props.questionNumber;
  const setSubmission = props.setSubmission;
  let options = props.options || [];

  function Setup() {
    let submit = submission;
    if (submit[questionNumber] === undefined) submit[questionNumber] = ["", ""];
    setSubmission(submit);
  }

  function onSelected(e) {
    let submit = submission;
    let submit2 = submit[questionNumber]
      ? [...submit[questionNumber]]
      : ["", ""];
    submit2[1] = e.target.innerHTML;
    submit[questionNumber] = submit2;
    setSubmission(submit);

    // Keep input focused after selecting an option
    if (inputRef.current) {
      inputRef.current.focus();
    }
    setQuestionRerender(!questionRerender);
  }

  function onChange(e) {
    const value = e.target.value;
    setSubmission((prevSubmission) => {
      const newSubmission = { ...prevSubmission };
      const newSubmit2 = [...(newSubmission[questionNumber] || [])];
      newSubmit2[0] = value;
      newSubmission[questionNumber] = newSubmit2;
      return newSubmission;
    });
  }

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [questionRerender, submission]);

  function Options() {
    return (
      <Div>
        {options.map((option, i) => {
          const letter = NumberToLetter(i);

          let formattedText = formatLatexText(option.text );
          return (
            <div
              key={"Text".concat(letter)}
              style={{ display: "flex", fontSize: "0.9rem" }}
            >
              <div
                style={{
                  flex: 3,
                  textAlign: "right",
                  paddingRight: "0.5em",
                  fontSize: "0.9rem",
                }}
              >
                <span style={{ fontSize: "0.9rem" }}>
                  {letter.concat(". ")}
                </span>
              </div>
              <div style={{ flex: 17, textAlign: "left", fontSize: "0.9rem" }}>
                <Latex>{formattedText}</Latex>
                <Image src={option.url} width="150px" />
              </div>
            </div>
          );
        })}
      </Div>
    );
  }

  function OptionSelectButtons() {
    return (
      <Div
        padding={"0 10px"}
        margin={fixMarginQuestionButtons(options.length)}
        bottom={"0"}
        position={"relative"}
      >
        {options.map((_, i) => {
          const letter = NumberToLetter(i);
          return MakeButton(letter, options.length);
        })}
      </Div>
    );
  }

  function MakeButton(text, numberOption) {
    const highlighted =
      submission[questionNumber] && submission[questionNumber][1] === text;

    const buttonWidth =
      (window.innerWidth - numberOption * 2 * 3) / (2 * numberOption);

    return (
      <Button
        key={"Button".concat(text)}
        onClick={onSelected}
        width={"60px"}
        height={"40px"}
        margin={"2px 3px"}
        backgroundColor={
          highlighted ? "rgba(16,44,79,0.4)" : "rgba(16,44,79,1)"
        }
        color={"#FFFFFF"}
        borderRadius={"5px"}
        fontWeight={"bold"}
      >
        {text}
      </Button>
    );
  }

  useEffect(() => {
    Setup();
    return () => {};
  }, []);

  return (
    <div style={{ height: "100%", borderRadius: "1px" }}>
      <div style={{ overflowY: "auto", height: "80%" }}>
        <QuestionText question={question} />
        <Image src={question.url} width="200px" />
        {options.length ? Options() : null}
        <Div margin={tenzero}>
          <InputBox
            ref={inputRef}
            type="text"
            padding={tentwentyfive()}
            onChange={onChange}
            id="answer"
            border="#00112e solid 1px"
            backgroundColor="white"
            color="#00112e"
            borderRadius="5px"
            width="65%"
            value={
              submission[questionNumber] && submission[questionNumber][0]
                ? submission[questionNumber][0]
                : ""
            }
            placeholder="Answer..."
          />
        </Div>
      </div>
      {options.length !== 0 ? OptionSelectButtons() : null}
    </div>
  );
}
